(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldSettingsButton', fbFieldSettingsButton);

    function fbFieldSettingsButton() {
        return {
            restrict: 'E',
            controller: fbFieldSettingsButtonCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/settings/button',
            scope: {
                element: '=',
                model: '='
            }
        };
    }

    function fbFieldSettingsButtonCtrl(lodash, $element, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.getSpinnerColor = getSpinnerColor;
            vm.click = click;
            vm.iconClass = 'hide';
            vm.buttonClass = 'hide';
            vm.click = click;

            init();
        }

        function init() {
            getIconClass();
            getButtonClass();
        }

        function getIconClass() {
            vm.iconClass = 'fa-' + lodash.get(vm, 'element.options.button.icon', 'hide');
        }

        function getButtonClass() {
            vm.buttonClass = lodash.get(vm, 'element.options.button.class', 'hide');
        }

        function getSpinnerColor() {
            if (vm.element.options.button.class.indexOf('default') >= 0) {
                return "#888888";
            }
        }

        function click($event) {
            if  (lodash.get(vm.pageData, 'fbData.settings.view_only', false)) {
                return;
            }
            vm.element.loading = true;
            var eventData = {
                targetScope: vm.element,
                target: $element,
                event: $event
            };

            if (lodash.has($scope, '$parent.vm.formIdentifier')) {
                vm.formIdentifier = $scope.$parent.vm.formIdentifier;
                var fbService = FormBuilderService.get(vm.formIdentifier);
                lodash.set(eventData, 'model', fbService.model || {});
                lodash.set(eventData, 'formIdentifier', vm.formIdentifier);
            }

            if (lodash.has(vm, 'element.event.click')) {
                $scope.$emit(vm.element.event.click, eventData);
            }
        }
    }
})();